/**
 * Number of times a queued request is sent before it is discarded.
 * A failing request is retried so a temporary network problem cannot silently
 * throw away user data, but it may not block the queue forever either.
 */
export const REQUEST_MAX_ATTEMPTS = 3;

/**
 * Delay before a failed request is retried. Without a delay a request that keeps
 * failing spins the queue at full speed.
 */
export const REQUEST_RETRY_DELAY = 5000;

/**
 * Form field name the api expects the uploaded files under.
 */
export const REQUEST_FILES_FORM_KEY = 'files';

/**
 * Chunk size used when converting base64 to a Blob, keeps peak memory low
 * for the multi megabyte photos a phone camera produces.
 */
export const BASE64_SLICE_SIZE = 512;
